import classnames from 'classnames';

// 被第三方嵌入
export const isThreePartEmbed = window.parent !== window.top;

/**
 * 向第三方发送`token`失效消息
 */
export function sendMsg(data = {}) {
  if (isThreePartEmbed) {
    window.top?.postMessage({ type: 'cloudstudio', ...data }, '*');
  }
}

// getMode Params
export const getMode = () => {
  const search = new URLSearchParams(location.search);
  return search.get('mode');
};

// add club cls
export const addClubCls = (styles, key, addon) => {
  return classnames({
    [styles[key]]: true,
    [styles[`${key}-club`]]: !!getMode(),
    [styles[`${key}-${addon}-club`]]: !!addon && !!getMode(),
  });
};
